<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <ValidationObserver ref="observer">
      <div class="mt-5 vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-5">
            <li>
              <router-link to="/provisionCommand" class="vx-row">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("system.label.EditProvisioningMapping") }}</h4>
              </router-link>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("system.label.ProvisioningSystem")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.ProvisioningSystem')"
                >
                  <v-select
                    label="item"
                    v-model="provisioningMapping"
                    :options="proSystemList"
                    @input="selectedProvisioningM(provisioningMapping)"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.item
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("system.label.CommandName")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.CommandName')"
                >
                  <v-select
                    label="item"
                    v-model="commandName"
                    :options="commandNameList"
                    @input="selectedCommandName(commandName)"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.item
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full">
              <h4>{{ $t("system.label.Parameters") }}</h4>
            </div>
            <div class="vx-col w-full">
              <div class="vx-row mb-5">
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/6">
                  <vs-input
                    :label="$t('system.label.CommandParams')"
                    class="w-full mb-5 font-semibold inputWithLable"
                    v-model="singleParameters.commandParam"
                  />
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/6">
                  <div class="dropdown-with-label">
                    <v-select
                      label="item"
                      v-model="singleParameters.paramType"
                      :options="selectOption"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="mb-2"
                    >
                      <template v-slot:option="option">{{
                        option.item
                      }}</template>
                    </v-select>
                  </div>
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/6">
                  <div class="">
                    <vs-input
                      v-if="
                        singleParameters.paramType == 'Text' ||
                        singleParameters.paramType == 'Combo' ||
                        singleParameters.paramType == '' ||
                        singleParameters.paramType == null
                      "
                      v-model="singleParameters.paramDefault"
                      :label="$t('system.label.ParamDefault')"
                      class="w-full mb-5 font-semibold"
                    />
                    <div
                      class="dropdown-with-label"
                      v-if="
                        singleParameters.paramType == 'Date' ||
                        singleParameters.paramType == 'Date Time'
                      "
                    >
                      <datepicker
                        v-model="singleParameters.paramDefault"
                        :placeholder="$t('placeholder.label.SelectDate')"
                        class="mb-2 font-semibold"
                      />
                    </div>
                    <div
                      class="dropdown-with-label"
                      v-if="singleParameters.paramType == 'Boolean'"
                    >
                      <v-select
                        label="item"
                        v-model="singleParameters.paramDefault"
                        :options="optionBoolean"
                        :placeholder="$t('placeholder.label.SelectOne')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="mb-2"
                      >
                        <template v-slot:option="option">{{
                          option.item
                        }}</template>
                      </v-select>
                    </div>
                    <vs-input
                      v-if="singleParameters.paramType == 'Integer'"
                      type="number"
                      v-model="singleParameters.paramDefault"
                      :label="$t('system.label.ParamDefault')"
                      class="w-full mb-5 font-semibold"
                    />
                  </div>
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/6">
                  <vs-input
                    v-model="singleParameters.paramLength"
                    :label="$t('system.label.ParamLength')"
                    class="w-full mb-5 font-semibold"
                  />
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/6">
                  <vs-input
                    v-model="singleParameters.paramNotes"
                    :label="$t('system.label.ParamNotes')"
                    class="w-full mb-5 font-semibold"
                  />
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/6">
                  <vs-button
                    color="primary"
                    type="border"
                    class="mb-2 plusbtn"
                    :disabled="disabledAddButton"
                    @click="addParametersClone"
                  >
                    <feather-icon
                      icon="PlusIcon"
                      class="plusiconbtn icon_row"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
                    />
                  </vs-button>
                </div>
              </div>
            </div>

            <div class="vx-col w-full" v-if="parametersTable.length > 0">
              <div class="vx-row">
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/6">
                  <h5>{{ $t("system.label.CommandParams") }}</h5>
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/6">
                  <h5>{{ $t("system.label.ParamType") }}</h5>
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/6">
                  <h5>{{ $t("system.label.ParamDefault") }}</h5>
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/6">
                  <h5>{{ $t("system.label.ParamLength") }}</h5>
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/6">
                  <h5>{{ $t("system.label.ParamNotes") }}</h5>
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/6">
                  <h5>{{ $t("system.label.Actions") }}</h5>
                </div>
              </div>
              <div
                class="vx-row"
                v-for="(paraTableShow, index) in this.parametersTable"
                :key="index"
              >
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/6">
                  <vs-input
                    :label="$t('system.label.CommandParams')"
                    class="w-full mb-5 font-semibold inputWithLable"
                    v-model="paraTableShow.commandParam"
                  />
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/6">
                  <div class="dropdown-with-label">
                    <v-select
                      label="item"
                      @input="updateArray"
                      v-model="paraTableShow.paramType"
                      :options="selectOption"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="mb-2"
                    >
                      <template v-slot:option="option">{{
                        option.item
                      }}</template>
                    </v-select>
                  </div>
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/6">
                  <div class="">
                    <vs-input
                      v-if="
                        singleParameters.paramType == 'Text' ||
                        singleParameters.paramType == 'Combo' ||
                        singleParameters.paramType == '' ||
                        singleParameters.paramType == null
                      "
                      v-model="paraTableShow.paramDefault"
                      :label="$t('system.label.ParamDefault')"
                      class="w-full mb-5 font-semibold"
                    />
                    <div
                      class="dropdown-with-label"
                      v-if="
                        singleParameters.paramType == 'Date' ||
                        singleParameters.paramType == 'Date Time'
                      "
                    >
                      <datepicker
                        v-model="paraTableShow.paramDefault"
                        :placeholder="$t('placeholder.label.SelectDate')"
                        class="mb-2 font-semibold"
                      />
                    </div>
                    <div
                      class="dropdown-with-label"
                      v-if="singleParameters.paramType == 'Boolean'"
                    >
                      <v-select
                        label="item"
                        v-model="paraTableShow.paramDefault"
                        :options="optionBoolean"
                        :placeholder="$t('placeholder.label.SelectOne')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="mb-2"
                      >
                        <template v-slot:option="option">{{
                          option.item
                        }}</template>
                      </v-select>
                    </div>
                    <vs-input
                      v-if="singleParameters.paramType == 'Integer'"
                      type="number"
                      v-model="paraTableShow.paramDefault"
                      :label="$t('system.label.ParamDefault')"
                      class="w-full mb-5 font-semibold"
                    />
                  </div>
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/6">
                  <vs-input
                    v-model="paraTableShow.paramLength"
                    :label="$t('system.label.ParamLength')"
                    class="w-full mb-5 font-semibold"
                  />
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/6">
                  <vs-input
                    v-model="paraTableShow.paramNotes"
                    :label="$t('system.label.ParamNotes')"
                    class="w-full mb-5 font-semibold"
                  />
                </div>
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/6">
                  <feather-icon
                    icon="TrashIcon"
                    :title="$t('system.label.Delete')"
                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                    class="ml-2 mt-6 icon_row"
                    @click="deletePara(index)"
                  />
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("system.label.cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="updatecommand"
            >{{ $t("system.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import vSelect from "vue-select";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  data() {
    return {
      breadcrumbs: [
        { name: this.$t("reports.label.configurations"), to: "" },
        {
          name: this.$t("system.label.ProvisionCommand"),
          to: "/provisionCommand",
        },
        {
          name: this.$t("system.label.EditProvisioningMapping"),
          to: "/",
        },
      ],
      provisioningData: {},
      provisioningMapping: "",
      proSystemList: [],
      provisioningId: 0,
      commandName: "",
      commandNameList: [],
      commandsId: 0,
      selectOption: [
        "Text",
        "Combo",
        "Date",
        "Boolean",
        "Date Time",
        "Integer",
      ],

      optionBoolean: ["True", "False"],
      parametersTable: [],
      singleParameters: {
        commandParam: "",
        paramType: "",
        paramDefault: "",
        paramLength: "",
        paramNotes: "",
      },
    };
  },
  components: {
    Datepicker,
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    disabledAddButton() {
      if (
        this.singleParameters.commandParam &&
        this.singleParameters.paramType &&
        this.singleParameters.paramLength &&
        this.singleParameters.paramNotes &&
        this.singleParameters.paramDefault
      ) {
        return false;
      } else return true;
    },
  },
  methods: {
    updateArray() {
      this.parametersTable = [...this.parametersTable];
    },
    async dataByIdProvisioning() {
      try {
        const response = await this.$store.dispatch(
          "provisioningConfig/seteditdataByIdProvisioning",
          this.$route.params.id
        );
        this.provisioningDataId = response.data;
        this.provisioningMapping =
          this.provisioningDataId.provisioningSystemName;
        this.provisioningId = this.provisioningDataId.provisioningSystem;
        this.commandName = this.provisioningDataId.commandName;
        this.parametersTable = this.provisioningDataId.commandParameters;
      } catch (error) {
        console.log(error);
      }
    },
    populateDropdownLists() {
      for (let role of this.provisioningDataId.networkElementDatas) {
        this.proSystemList.push(role.systemcode);
      }
      for (let role of this.provisioningDataId.commands) {
        this.commandNameList.push(role.mCodeValue);
      }
    },
    selectedProvisioningM(off) {
      this.provisioningDataId.networkElementDatas.map((e) => {
        if (e.systemcode == off) {
          this.provisioningId = e.id;
        }
      });
    },
    selectedCommandName(off) {
      this.provisioningDataId.commands.map((e) => {
        if (e.mCodeValue == off) {
          this.commandsId = e.id;
        }
      });
    },
    async updatecommand() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      let payload = {
        commandName: this.commandName,
        provisioningSystem: this.provisioningId,
        commandParameters: this.parametersTable,
      };
      await this.$store.dispatch(
        "provisioningConfig/updateProvisioningAction",
        { id: this.$route.params.id, data: payload }
      );
      this.$swal({
        title: "Success",
        icon: "success",
        text: "Provisioning Command Edited Successfully!",
        type: "success",
      });
      this.$router.push("/provisionCommand");
    },
    cancel() {
      this.$router.push("/provisionCommand");
    },
    addParametersClone() {
      let obj = { ...this.singleParameters };
      this.parametersTable.push(obj);

      (this.singleParameters.commandParam = ""),
        (this.singleParameters.paramType = ""),
        (this.singleParameters.paramLength = ""),
        (this.singleParameters.paramNotes = ""),
        (this.singleParameters.paramDefault = "");
    },
    deletePara(index) {
      this.parametersTable.splice(index, 1);
    },
  },
  filters: {
    formatedate: function (value) {
      if (value) {
        return moment(String(value)).format("DD-MMM-YYYY");
      }
    },
  },

  mounted() {
    this.dataByIdProvisioning().then(() => {
      this.populateDropdownLists();
    });
  },
};
</script>
<style>
.plusiconbtn {
  background: #ddd;
  height: 40px;
  width: 40px;
  text-align: center;
  line-height: 40px;
  display: block;
  border-radius: 50%;
  font-size: 26px;
  font-weight: bold;
  margin-top: 13px;
}
.plusbtn {
  background: transparent;
  border: none;
  padding: 0 !important;
}
.plusbtn:hover {
  background: transparent !important;
  border: none;
  padding: 0 !important;
}
.vs-con-input-label .vs-input--label {
  font-size: 12px !important;
}
</style>
